// === List View Item Creation ===

import { escapeHtml } from '../utils/dom.js';
import { isDone } from '../services/completion-service.js';

export function createListItem(item, isUrgent) {
  const done = isDone(item.id);
  const container = document.createElement('div');
  container.id = `list-item-${item.id}`;
  container.className = `list-item ${isUrgent ? 'urgent-item' : ''} ${done ? 'done-item' : ''}`;

  const statusIcon = done
    ? `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" /></svg>`
    : `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>`;

  // Clicking the row opens the detail modal; Complete stops propagation.
  container.innerHTML = `
      <div class="list-header" role="button" tabindex="0"
           onclick="app.openCard('${item.id}')"
           onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();app.openCard('${item.id}')}">
         <div class="list-status-icon">${statusIcon}</div>
         <div class="list-main">
            <div class="list-meta">
               <span class="list-badge">${escapeHtml(item.meta.category)}</span>
            </div>
            <h4 class="list-title">${escapeHtml(item.content.title)}</h4>
         </div>

         <button class="btn btn-complete ${done ? 'is-done' : ''}" onclick="app.toggle('${item.id}', event)">
           ${done ? 'Done' : 'Complete'}
         </button>

         <div class="list-expand-icon" aria-hidden="true">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20">
             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
           </svg>
         </div>
      </div>
  `;
  return container;
}
